module.exports = __webpack_public_path__ + "static/img/articleLayoutOff.63b2da5a.svg";